import { render, staticRenderFns } from "./BrokerDetails.vue?vue&type=template&id=08c44148&scoped=true"
import script from "./BrokerDetails.vue?vue&type=script&lang=js"
export * from "./BrokerDetails.vue?vue&type=script&lang=js"
import style0 from "./BrokerDetails.vue?vue&type=style&index=0&id=08c44148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c44148",
  null
  
)

export default component.exports